var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Nav',{attrs:{"list":_vm.list},on:{"click":_vm.menuClick}}),_c('router-view'),_c('Dialog'),_c('Copy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }